import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Divider } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';

import * as DateUtils from 'Util/DateUtils';
import { getConfig } from 'Util/Config';
import { FONT_SIZE, COLOR, SPACE } from 'Components/Theme';
import { Text, Link, Icon, Box, Flex, Button } from 'Components/Base';
import MockExamDataCard from 'Components/MockExamDataCard';
import DataForm from 'Components/DataForm';
import { EmptyFacultyModal } from 'Components/FavFaculty';
import { QueryComponent } from 'GraphQL';
import { studentProfileWithExamRound } from 'GraphQL/query/MockExamManage.query';
import EditProfile from 'Containers/StudentProfile/EditProfile.gql';
import MostDepartmentCard from 'Containers/MostDepartmentCard';
import StudentExamsList from 'Containers/StudentExamsList';
import { BrowseUniversityModal } from 'Containers/BrowseUniversity';

import AppContainer from '../AppContainer';

class LinkWithHref extends Component {
  static propTypes = {
    href: PropTypes.string,
  };

  handleClick = evt => {
    evt.preventDefault();
    const { history, href } = this.props;
    history.push(href);
  };

  render() {
    const { staticContext, history, location, match, ...restProps } = this.props;
    return <Link {...restProps} onClick={this.handleClick} />;
  }
}

const LinkWithRouter = withRouter(LinkWithHref);

const Toolbar = ({ title = 'จัดการสอบ', roundTitle }) => (
  <Box mb={[2, 0]}>
    <LinkWithRouter fontSize={[FONT_SIZE.large]} href="/mockexam" is="a">
      หน้าหลัก
    </LinkWithRouter>
    <Text fontSize={[FONT_SIZE.large]} color={COLOR.borderGrey} mx={1} is="span">
      /
    </Text>
    <Text fontSize={[FONT_SIZE.large]} is="span">
      {title}
    </Text>
    <Text pl={10} is="span">{`: รอบ ${roundTitle}`}</Text>
  </Box>
);

export function getMockExamDate({ examStartDate, examEndDate }, examDateStr) {
  if (examStartDate && examEndDate) return DateUtils.generateDateRange(examStartDate, examEndDate);
  return examDateStr;
}

const ExamRoundErrorText = ({ roundCode }) => {
  const lineContactLink = getConfig().lineContactLink;
  return (
    <Flex justifyContent="center">
      <Box css={{ textAlign: 'center' }}>
        <Text fontSize={[FONT_SIZE.medium]} mb={3}>{`ไม่พบรอบการสอบรหัส ${roundCode}`}</Text>
        <Text fontSize={[FONT_SIZE.medium]} style={{ display: 'inline-block' }} mr={SPACE.xsmall}>
          {`กรุณาติดต่อผ่าน Line:`}
        </Text>
        <Link
          fontSize={[FONT_SIZE.medium]}
          style={{ display: 'inline-block' }}
          href={lineContactLink}
          color={COLOR.primary}
        >
          @tcastermock
        </Link>
      </Box>
    </Flex>
  );
};

const StudentProfileErrorText = ({ roundTitle, onSchoolLinkClick }) => {
  return (
    <Flex justifyContent="center">
      <Box css={{ textAlign: 'center' }}>
        <Text
          fontSize={[FONT_SIZE.medium]}
          mb={3}
        >{`ผู้ใช้ยังไม่ได้เชื่อมระบบโรงเรียนในรอบ ${roundTitle}`}</Text>
        <Button
          type="submit"
          primary
          circular
          style={{
            minWidth: '100px',
          }}
          onClick={onSchoolLinkClick}
        >
          <Text is="span" fontWeight="500" fontSize={[FONT_SIZE.medium]} color={COLOR.white}>
            เชื่อมระบบโรงเรียนได้ที่นี่
          </Text>
        </Button>
      </Box>
    </Flex>
  );
};

class MockExamManage extends Component {
  state = {
    editMode: false,
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  handleEditForm = () => {
    this.setState({
      editMode: true,
    });
  };

  handleSuccessEditForm = () => {
    this.setState({
      editMode: false,
    });
  };

  handleSchoolLinkClick = () => {
    const { match, history } = this.props;
    const {
      params: { roundCode },
    } = match;
    history.push(`/school/${roundCode}`);
  };

  handleGoToMockExamResultClick = () => {
    const { history } = this.props;
    history.push(`/mockexam`);
  };

  render() {
    const { menus, match } = this.props;
    const {
      params: { roundCode: encodedRoundCode },
    } = match;
    // TODO: check & redirect when not sync data to schoolid, roundid
    const { editMode } = this.state;
    const roundCode = decodeURIComponent(encodedRoundCode);

    return (
      <AppContainer menus={menus}>
        <QueryComponent query={studentProfileWithExamRound} variables={{ roundCode }}>
          {data => {
            const { mockExamStudentProfile, mockExamSchoolRound } = data || {};

            if (!mockExamSchoolRound) {
              return <ExamRoundErrorText roundCode={encodedRoundCode} />;
            }

            const roundTitle = mockExamSchoolRound ? mockExamSchoolRound.title : '';

            if (!mockExamStudentProfile) {
              return (
                <StudentProfileErrorText
                  roundTitle={roundTitle}
                  onSchoolLinkClick={this.handleSchoolLinkClick}
                />
              );
            }

            const { departmentId, locationCode, enabledExamCardControl } = mockExamStudentProfile;

            return (
              <Box>
                <Toolbar roundTitle={roundTitle} />
                <Divider />
                <Flex flexDirection="column">
                  <Flex flexWrap="wrap">
                    <Flex width={[1, 1, 1 / 2]} pr={[0, 0, SPACE.medium]}>
                      {editMode ? (
                        <EditProfile
                          profile={mockExamStudentProfile}
                          roundCode={mockExamStudentProfile.roundCode}
                          onSuccess={this.handleSuccessEditForm}
                        />
                      ) : (
                        <MockExamDataCard
                          onClickLink={this.handleEditForm}
                          headText="ข้อมูลของน้อง"
                          linkText="แก้ไขข้อมูล"
                        >
                          <DataForm profile={mockExamStudentProfile} />
                        </MockExamDataCard>
                      )}
                    </Flex>
                    <Flex width={[1, 1, 1 / 2]} pt={[SPACE.medium, SPACE.medium, 0]}>
                      <MockExamDataCard
                        ModalLink={
                          departmentId && (
                            <BrowseUniversityModal
                              trigger={
                                <Link is="a" color="primary">
                                  {`แก้ไขคณะ`}
                                </Link>
                              }
                              mockExam
                              hideHeart
                              roundCode={roundCode}
                            />
                          )
                        }
                        headText="คณะที่น้องอยากเข้าที่สุด"
                      >
                        {departmentId ? (
                          <MostDepartmentCard hideHeart depId={departmentId} />
                        ) : (
                          <EmptyFacultyModal roundCode={roundCode} image="/emptyDepartment.png" />
                        )}
                      </MockExamDataCard>
                    </Flex>
                  </Flex>
                  <Box mt={SPACE.large}>
                    <StudentExamsList
                      roundCode={roundCode}
                      locationCode={locationCode}
                      roundTitle={roundTitle}
                      enabledExamCardControl={enabledExamCardControl}
                      titleActionComponent={
                        <Button primary circular onClick={this.handleGoToMockExamResultClick}>
                          <Icon name="insert_drive_file" iconStyle={{ verticalAlign: 'top' }} />{' '}
                          ดูผลสอบ
                        </Button>
                      }
                    />
                  </Box>
                </Flex>
              </Box>
            );
          }}
        </QueryComponent>
      </AppContainer>
    );
  }
}

export default withRouter(MockExamManage);
